import {
  deleteGroup,
  getGroups,
  saveGroup,
  type TTransportPerformanceGroups,
} from 'shared/stores/helpers/transport-performance-groups-helper';
import { createStore } from './create-store';

export const ALL_TAB_KEY = 'all';

type TState = {
  groups: TTransportPerformanceGroups;
  activeTab: string;
  selectedIds: number[];
};

type TActions = {
  setActiveTab: (key: string) => void;
  setSelectedIds: (ids: number[]) => void;
  addGroup: (name: string, ids: number[]) => void;
  addToGroup: (name: string, ids: number[]) => void;
  removeGroup: (name: string) => void;
  removeFromGroup: (name: string, ids: number[]) => void;
};

export const useTransportPerformanceGroupsStore = createStore<TState & TActions>(
  (set) => ({
    groups: getGroups(),
    activeTab: ALL_TAB_KEY,
    selectedIds: [],

    setActiveTab: (key) => set({ activeTab: key, selectedIds: [] }),

    setSelectedIds: (selectedIds) => set({ selectedIds }),

    addGroup: (name, ids) => set({ groups: saveGroup(name, ids) }),

    addToGroup: (name, ids) =>
      set((state) => {
        const existingIds = state.groups[name] || [];
        const newIds = ids.filter((id) => !existingIds.includes(id));

        return { groups: saveGroup(name, [...existingIds, ...newIds]), selectedIds: [] };
      }),

    removeGroup: (name) =>
      set((state) => {
        const groups = deleteGroup(name);
        const activeTab = state.activeTab === name ? ALL_TAB_KEY : state.activeTab;

        return { groups, activeTab, selectedIds: [] };
      }),

    removeFromGroup: (name, ids) =>
      set((state) => {
        const removeSet = new Set(ids);
        const remaining = (state.groups[name] || []).filter((id) => !removeSet.has(id));

        if (remaining.length === 0) {
          return { groups: deleteGroup(name), activeTab: ALL_TAB_KEY, selectedIds: [] };
        }

        return { groups: saveGroup(name, remaining), selectedIds: [] };
      }),
  }),
  'transport-performance-groups-store',
);
